// extracted by mini-css-extract-plugin
export var icon = "_60-3";
export var subtitle = "_60-2";
export var title = "_60-1";
export var value = "_60-0";